import axios from 'axios';

type AwsFields = Record<string, string> & {
    key: string;
};

type UploadProgress = { loaded: number; total: number };

type UploadProgressEvent = (progress: UploadProgress) => void;

type UploadSeed = {
    url: string;
    fields: AwsFields;
};

type UploadFileParams = UploadSeed & {
    file: File;
    onUploadProgress?: UploadProgressEvent;
};

const uploadFile = async ({
    file,
    url,
    fields,
    onUploadProgress,
}: UploadFileParams): Promise<void> => {
    const form = new FormData();
    Object.entries(fields).forEach(e => form.append(...e));
    form.append('file', file);
    await axios.request({
        method: 'POST',
        url: url,
        data: form,
        withCredentials: false,
        onUploadProgress,
    });
};

export default { uploadFile };
export type {
    UploadSeed,
    UploadProgress,
    UploadFileParams,
    UploadProgressEvent,
};
